import { Table as BSTable } from 'react-bootstrap';
import styled from 'styled-components';

export const BSTableStyled = styled(BSTable)``;
